import { TableDetailsItemDto } from "../../services/tables/dto/table-details-dto";
import { TableItemOption } from "./table-item-option";

export type TableItemType = 'NORMAL' | 'WEIGHTABLE' | 'SERVICE';

export class TableItem {
  id: number;
  name: string;
  qty: number;
  value: number;
  status: string;
  tableItemId: number;
  additionalInfo?: string;
  type?: TableItemType;
  options: TableItemOption[];
  qtySelected: number = 0;

  /** users.id de quem pediu; null quando sem dono */
  userId: number | null = null;
  userName: string | null = null;
  /** quantos itens do grupo são do usuário logado */
  qtyOwned: number = 0;

  qtyGrouped: number = 0;
  valueGrouped: number = 0;

  groupedItemsId: number[] = [];

  tip?: boolean;

  constructor(item: TableDetailsItemDto) {
    this.id = item.id;
    this.name = item.name;
    this.qty = item.qty;
    this.value = item.value;
    this.status = item.status;
    this.tableItemId = item.tableItemId;
    this.additionalInfo = item.additionalInfo;
    this.type = item.type as TableItemType;
    this.userId = item.userId ?? null;
    this.userName = item.userName ?? null;
    this.options = [];
    this.tip = this.name == "Taxa de serviço"
    if(item.options) {
      for(let option of item.options) {
        this.options.push(new TableItemOption(option));
      }
    }
  }

  get totalSelected() {
    return this.qtySelected * this.value;
  }

  isService(): boolean {
    return this.type === 'SERVICE';
  }
}
